import styled from 'styled-components';
import { Button } from '@minerva-analytics/pantheon';

import media from './oldpantheon/utils/media';
import { BLACK, TEAL } from './theme';

const LARGE_TABLET = `80.9rem`;

export const StyledButton = styled(Button)`
  background-color: #ffffff;
  padding: .75rem 2.75rem;
  border-radius: 3rem;
  border-width: 3px;
  border: 1px solid ${BLACK};
  color: ${BLACK};
  box-shadow: 3px 3px ${TEAL};
  transition-duration: .15s;
  margin: 0 auto;
  display: block;
  font-weight: bolder;
  font-size: 1rem;
  cursor: pointer;

  &:hover {
    background-color: #ffffff;
    box-shadow: none;
    transform: translate(3px, 3px);
    color: ${BLACK};
  }

  @media (max-width: 26.5rem) {
    padding: .75rem 2rem
  }

  @media only screen and (max-width: 21.875rem) {
    padding: .75rem .9rem;
  }
`;

export const ShadowContentCard = styled.div`
  background-color: #ffffff;
  width: 85%;
  max-width: 53.125rem;
  border-radius: 0.625rem;
  border: 1px solid ${BLACK};
  box-shadow: 0.625rem 0.625rem ${TEAL};
  padding: 2rem 4rem;
  box-sizing: border-box;
  margin: 4rem auto;
  display: block;
  color: ${BLACK};

  ${media.extraSmall`
    width: 100%;
    border: 1px solid #DAF3F5;
    box-shadow: 0 0.125rem 1rem rgba(0,0,0,.08);
    border-radius: 0px;
    padding: 1rem 1.5rem;
    margin: 0rem 0rem 2rem 0rem;
  `}

  a {
    text-decoration: none;
  }
`;

export const ContentCard = styled.div`
  background-color: #ffffff;
  max-width: 30rem;
  width: 49%;
  border-radius: 0.625rem;
  border: 1px solid #D6D6D6;
  padding: 2rem;
  box-sizing: border-box;
  margin-top: 1rem;
  justify-content: space-between;
  
  @media (max-width: ${LARGE_TABLET}) {
    margin: 4rem auto 0px;
  }

  ${media.tablet`
    width: 85%;
  `}

  ${media.extraSmall`
    display: block;
    margin: 3rem auto 0 auto;
    padding: 1.25rem 1rem 1.5rem 1rem;
  `}
`;

export const AdWrapper = styled.div`
  margin: 25px auto;
  width: 100%;
  display: flex;
  justify-content: center;
`;
